/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledH4 = styled.h4`
    font-weight: 700;
    font-size: 22px;
`;
